import httpServices from 'services/http.service';
import { API_URLS } from 'constants/index';

export const getCategories = () => httpServices.get(API_URLS.CATEGORY.LIST);
